module.exports = __webpack_public_path__ + "static/media/download-app-page.550e67e7.png";